<template>
    <div>
        <component v-if="clientSpecificModal" :is="clientSpecificModal.component"/>
        <HomeNew v-if="newHomepageConfig" />
        <HomeOriginal v-else/>
    </div>
</template>
<script>

import HomeOriginal from '@/components/HomeOriginal.vue';
import HomeNew from '@/components/newHomepage/HomeNew.vue';
import launchCommsModal from '@/components/clientSpecific/ICI/launchCommsModal.vue';


export default {
    components: {
        HomeOriginal,
        HomeNew,
        launchCommsModal,
    },
    data () {
        return {
            showModal: true,
        };
    },
    computed: {

        newHomepageConfig () {
            return this.$store.getters['clientConfig/clientConfig'].newHomepage;
        },
        modalConfig () {
            return {
                headerText: 'Important message about your new Fund administrator',
                body: '<p>Your new Fund administrator is Lane Clark & Peacock. The announcements below provide more information.</p>',
            };
        },
        clientSpecificModal () {
            return this.$store.state.clientConfig.clientSpecificModal;
        },

    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
